import { dataSourceList } from '@/resources/data-source';
import { TextString } from '@/services/shape/attributes/text';
import { JSONContent } from '@tiptap/core';
import tinycolor from 'tinycolor2';

const getDataSourceLabel = (key: string) =>
  Object.entries(dataSourceList)
    .map((i) => i[1])
    .flat()
    .find((i) => i.key === key)?.label ?? '---';

export const tiptap2textString = (t: JSONContent): TextString[] => {
  const res: TextString[] = [];
  if (!t.content || !t.content[0].content) return [];
  for (const i of t.content[0].content) {
    let cur: TextString;
    if (i.type === 'datasource') {
      if (!(i.attrs && i.attrs.key)) throw '数据格式错误';
      cur = {
        isSource: true,
        value: i.attrs['key'],
        sourceFormat: i.attrs['sourceFormat']
      };
    } else {
      cur = {
        isSource: false,
        value: i.text ?? ''
      };
    }
    const color = i?.marks?.find((m) => m.type === 'textStyle')?.attrs?.[
      'color'
    ];
    if (color) cur.color = `#${tinycolor(color).toHex8()}`;
    res.push(cur);
  }
  return res;
};

export const textString2tiptap = (
  t: TextString[],
  overwritings?: { text: string }[]
): JSONContent => ({
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: t.map((i, idx) => ({
        type: i.isSource ? 'datasource' : 'text',
        ...(i.color && {
          marks: [{ type: 'textStyle', attrs: { color: i.color } }]
        }),
        attrs: {
          ...(i.isSource && {
            key: i.value,
            renderingValue:
              overwritings?.[idx]?.text ?? getDataSourceLabel(i.value)
          }),
          ...(i.sourceFormat && { sourceFormat: i.sourceFormat })
        },
        ...(!i.isSource && { text: i.value })
      }))
    }
  ]
});

type valueStrings = { text: string; color: string }[];

export const tiptap2valueStrings = (t: JSONContent): valueStrings => {
  const res: valueStrings = [];
  if (!t.content || !t.content[0].content) return [];
  for (const i of t.content[0].content) {
    const color =
      i?.marks?.find((m) => m.type === 'textStyle')?.attrs?.['color'] ??
      '#ffffffff';
    const cur = {
      color: `#${tinycolor(color).toHex8()}`,
      text: i.text ?? ''
    };
    res.push(cur);
  }
  return res;
};

export const compareValueStrings = (t1: valueStrings, t2: valueStrings) => {
  const r1 = t1.map((i) => i.text);
  const r2 = t2.map((i) => i.text);
  return JSON.stringify(r1) !== JSON.stringify(r2);
};

export const isSameText = (strs: string[]) => {
  const [str, ..._strs] = strs;
  return _strs.every((item) => item === str);
};

export const isEmojiCharacter = (substring: string): boolean => {
  for (let i = 0; i < substring.length; i++) {
    const hs = substring.charCodeAt(i);
    if (0xd800 <= hs && hs <= 0xdbff) {
      if (substring.length > 1) {
        const ls = substring.charCodeAt(i + 1);
        const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
        if (0x1d000 <= uc && uc <= 0x1f77f) {
          return true;
        }
      }
    } else if (substring.length > 1) {
      const ls = substring.charCodeAt(i + 1);
      if (ls == 0x20e3) {
        return true;
      }
    } else {
      if (0x2100 <= hs && hs <= 0x27ff) {
        return true;
      } else if (0x2b05 <= hs && hs <= 0x2b07) {
        return true;
      } else if (0x2934 <= hs && hs <= 0x2935) {
        return true;
      } else if (0x3297 <= hs && hs <= 0x3299) {
        return true;
      } else if (
        hs == 0xa9 ||
        hs == 0xae ||
        hs == 0x303d ||
        hs == 0x3030 ||
        hs == 0x2b55 ||
        hs == 0x2b1c ||
        hs == 0x2b1b ||
        hs == 0x2b50
      ) {
        return true;
      }
    }
  }
  return false;
};

export const getCharLength = (str: string) => {
  let chineseCharNum = 0,
    otherCharNum = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    //基本汉字
    if (c.match(/[\u4e00-\u9fa5]/)) {
      chineseCharNum++;
    }
    //基本汉字补充
    else if (c.match(/[\u9FA6-\u9fcb]/)) {
      chineseCharNum++;
    } else {
      otherCharNum++;
    }
  }
  return chineseCharNum * 3 + otherCharNum;
};
